export default __webpack_public_path__ + "static/4-d88af3779a0a4d40e498b0cbeb8de836.jpeg";